import { Pencil, Check } from "lucide-react";

import { Input } from "@/shared/ui/input";
import { Button } from "@/shared/ui/button";
import { NotificationSettings } from "@/features/NotificationSettings";
import { Roles, type User } from "@/entities/user";
import { useProfileForm } from "../model/useProfileForm";
import { Modal } from "@/shared/ui/Modal";

interface ProfileFormProps {
  user: User | null;
}

export const ProfileForm = ({ user }: ProfileFormProps) => {
  const {
    username,
    setUsername,
    password,
    setPassword,
    notificationType,
    setNotificationType,
    handleUpdate,
    isDisabled,
    isBlocked,
    updateStatus,
    userData,
    headContact,
    setHeadContact,
  } = useProfileForm(user);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-2">
        <div className="flex-2 flex flex-col">
          <label htmlFor="login" className="font-semibold text-textColor">
            {user?.role === Roles.Worker ? "Никнейм для выплат" : "Никнейм"}
          </label>
          <Input
            id="login"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder={"Введите имя"}
            disabled={user?.role !== Roles.Worker}
            endIcon={user?.role !== Roles.Worker ? undefined : Pencil}
            className="text-textColor"
          />
        </div>
        <div className="flex flex-1 flex-col">
          <label htmlFor="role" className="font-semibold text-textColor">
            Роль
          </label>
          <Input
            id="role"
            readOnly
            value={user?.role}
            className="text-textColor"
          />
        </div>
      </div>
      <div className="flex flex-col">
        <label htmlFor="password" className="font-semibold text-textColor">
          Изменить пароль
        </label>
        <Input
          id="password"
          type="password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Введите пароль"
          endIcon={Pencil}
        />
      </div>

      {user?.role === Roles.Head && (
        <div className="flex flex-col">
          <label
            htmlFor="head-contact"
            className="font-semibold text-textColor"
          >
            Контакт для связи (хэд)
          </label>
          <Input
            id="head-contact"
            value={headContact}
            onChange={(e) => setHeadContact(e.target.value)}
            placeholder="Telegram / username / ссылка"
            className="text-textColor"
            endIcon={Pencil}
          />
        </div>
      )}

      <NotificationSettings
        notificationType={notificationType}
        setNotificationType={setNotificationType}
        userData={userData}
      />
      <div className="flex flex-col gap-2 max-md:pt-2">
        <Button
          className="w-full text-textColor"
          onClick={handleUpdate}
          variant="outline"
          disabled={isDisabled() || isBlocked}
        >
          {updateStatus === "success" ? (
            <Check />
          ) : updateStatus === "pending" ? (
            "Загрузка..."
          ) : (
            "Сохранить изменения"
          )}
        </Button>

        <Modal.Close />
      </div>
    </div>
  );
};
